import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import ArrowUpIcon from './Icons/ArrowUp';
import ArrowDownIcon from './Icons/ArrowDown';

const openingCollape = keyframes`
  0% { 
    max-height: 0;
  }
  100% { 
    max-height: 1000px;
  }
`;

const closeingCollape = keyframes`
  0% { 
    max-height: 1000px;
  }
  100% { 
    max-height: 0;
  }
`;

const CollapseWrapper = styled.div`
  .text-ab {
    /* Text lg/Medium */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    /* identical to box height, or 156% */

    color: #181d27;
    
  }
  .collapse-header,
  .collapse-title.collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    li {
      padding: 0;
      &:before {
        content: none;
      }
    }
  }
  h2 {
    margin: 0;
  }
  .arrow-down {
    transition: transform 0.3s ease-out;
    transform: rotate(0);
  }
  .open-arrow {
    transform: rotate(180deg);
  }
  .collapsible {
    overflow: hidden;
    max-height: 0;
    height: 0;
  }
  .collapsed {
    animation: ${closeingCollape} 0.5s forwards;
    height: 0;
  }
  .open-collaps {
    animation: ${openingCollape} 0.5s forwards;
    height: auto;
  }
`;

export default class Collapse extends Component {
  static propTypes = {
    titleMessage: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
    arrowWidth: PropTypes.string,
    defaultState: PropTypes.bool,
    handleMultiCollapes: PropTypes.func,
    witchQuestions: PropTypes.string,
  };
  state = {
    open: false,
  };
  handelCollapse = () => {
    const { defaultState, handleMultiCollapes, witchQuestions } = this.props;
    this.setState({ open: !this.state.open });
    if (handleMultiCollapes) {
      handleMultiCollapes(!defaultState, witchQuestions);
    }
  };

  render() {
    const { titleMessage, children, arrowWidth, defaultState } = this.props;
    const { open } = this.state;
    const collapseState =
      defaultState !== null && defaultState !== undefined ? defaultState : open;

    return (
      <CollapseWrapper {...this.props}>
        <div
          onClick={() => {
            this.handelCollapse();
          }}
          className="collapse-header collapse-title text-ab"
        >
          {titleMessage}

          {collapseState ? <ArrowUpIcon /> : <ArrowDownIcon />}

          {/*<SvgWrapper*/}
          {/*  width={arrowWidth ? arrowWidth : null}*/}
          {/*  height={arrowWidth ? arrowWidth : null}*/}
          {/*>*/}
          {/*  <ArrowDown*/}
          {/*    className={collapseState ? 'open-arrow arrow-down' : 'arrow-down'}*/}
          {/*  />*/}
          {/*</SvgWrapper>*/}
        </div>
        <ContentState
          className={
            collapseState ? 'collapsible open-collaps' : 'collapsible collapsed'
          }
        >
          {children}
        </ContentState>
      </CollapseWrapper>
    );
  }
}

const ContentState = styled.div`
  box-sizing: border-box;
  padding-right: 4px;
  
  ol {
    margin-bottom: 0;
  }
  ul {
    margin-bottom: 0;
  }
  
  p {
    margin: 0 0 0 0 !important;
  }
  
`
